import { Component, OnInit } from '@angular/core';
import {HttpService} from '../../../services/http.service';
import {Language} from '../../../models/disclaimer/language.model';
import {SweetUtil} from '../../commons/sweet/sweet-util-service';

@Component({
  selector: 'app-disclaimer-config',
  templateUrl: './disclaimer-config.component.html',
  styleUrls: ['./disclaimer-config.component.scss']
})
export class DisclaimerConfigComponent implements OnInit {

  english: Language;
  german: Language;
  french: Language;
  dutch: Language;

  constructor(private http: HttpService) { }

  ngOnInit(): void {
    this.fetchDisclaimers();
  }

  fetchDisclaimers() {
    this.http.fetchDisclaimers().subscribe((res) => {
      this.english = res.find(r => r.lang === 'en');
      this.german = res.find(r => r.lang === 'de');
      this.french = res.find(r => r.lang === 'fr');
      this.dutch = res.find(r => r.lang === 'nl');
    });
  }

  updateDisclaimers() {
    let data: Language[] = [];
    data.push(this.english);
    data.push(this.german);
    data.push(this.french);
    data.push(this.dutch);

    this.http.saveDisclaimers(data).subscribe(() => {
      SweetUtil.showSuccess('Saved').then();
    });
  }

  getLang(lang: string): string {
    switch (lang) {
      case 'en' : return 'English';
      case 'de' : return 'German';
      case 'fr' : return 'French';
      case 'nl' : return 'Dutch';
    }
  }

  back() {
    window.history.back();
  }

}
